import type { FaqItem } from "./affiliateContent"

export const supportFaqData: FaqItem[] = [
  {
    id: "faq-1",
    question: "How do I get help with To To-Do?",
    answer:
      "Our primary support channel is our Discord community. There, you can ask questions, report issues, and get help from both our team and other community members. For urgent issues, you can also tag our team members directly in Discord.",
  },
  {
    id: "faq-2",
    question: "How quickly will I get a response?",
    answer:
      "While we don't offer guaranteed response times as we're a small team, most questions in Discord receive responses within a few hours during working days. For complex issues, we might need a bit more time to investigate.",
  },
  {
    id: "faq-3",
    question: "I don't use Discord. Are there other ways to get support?",
    answer:
      "Discord is our main community hub and the fastest way to get help. However, if you're unable to use Discord, you can email us at support@totodo.app, though response times may be longer.",
  },
  {
    id: "faq-4",
    question: "How can I suggest new features?",
    answer:
      "We welcome feature suggestions! The best place to share your ideas is in the #feature-requests channel on our Discord server. The community can discuss and vote on ideas there, and our product team regularly reviews these discussions.",
  },
  {
    id: "faq-6",
    question: "I found a bug. How do I report it?",
    answer:
      "Please report bugs in the #bug-reports channel on Discord with as much detail as possible. Include steps to reproduce, screenshots if applicable, and what device/browser you're using. This helps us fix issues faster.",
  },
  {
    id: "faq-7",
    question: "How do I delete my account or request my data?",
    answer:
      "You can delete your account directly in the app or web by going to: Settings > Account > Delete account. For data access or erasure requests under applicable data protection regulations, please contact us via Discord or at support@totodo.app using the email associated with your account.",
  },
  {
    id: "faq-8",
    question: "How can I contribute to To To-Do?",
    answer:
      "There are many ways to contribute! You can help answer questions from other users on Discord, submit detailed bug reports, provide thoughtful feature suggestions, or even help with translations if we expand to more languages. Your involvement helps make To To-Do better for everyone.",
  },
]

export const supportFeatures = [
  {
    iconSrc: "/marketing/go/icons/offline.svg",
    title: "Fast & Personal Response",
    description:
      "Get help directly from our team and fellow users who understand the app inside and out, with real-time conversations.",
  },
  {
    iconSrc: "/marketing/go/icons/cross-plattform.svg",
    title: "Shape the Future",
    description:
      "Your feedback goes directly to the product team. Share ideas, vote on features, and help prioritize what matters most to users like you.",
  },
  {
    iconSrc: "/marketing/go/icons/ai.svg",
    title: "Community Connection",
    description:
      "Connect with others passionate about productivity. Share workflows, tips, and tricks to get the most out of To To-Do and your productivity system.",
  },
]

export const discordBenefits = [
  "Get fast responses from the team and fellow users",
  "Shape To To-Do's future with your ideas",
  "Connect with others passionate about productivity",
  "Get help with setup, features, and best practices",
]
